// Use general transition to target all properties, use general.durationAndTiming to target a specific property
// Ex. `transition: text-transform ${animation.general.durationAndTiming};`
export const animation = {
  general: {
    duration: '0.3s',
    durationAndTiming: '0.3s ease',
    timing: 'ease',
    transition: 'all 0.3s ease'
  }
};
